/**
 * Shared order status constants — single source of truth across order components.
 */

export const STATUS_COLORS = {
  pending:          '#bc9038',
  confirmed:        '#4169E1',
  in_progress:      '#9370DB',
  fulfilled:        '#32CD32',
  out_for_delivery: '#20B2AA',
  delivered:        '#228B22',
  ready_for_pickup: '#E6890A',
  picked_up:        '#2E7D32',
  cancelled:        '#DC143C',
};

export const STATUS_LABELS = {
  pending:          'Pending',
  confirmed:        'Confirmed',
  in_progress:      'In Progress',
  fulfilled:        'Fulfilled',
  out_for_delivery: 'Out for Delivery',
  delivered:        'Delivered',
  ready_for_pickup: 'Ready for Pickup',
  picked_up:        'Picked Up',
  cancelled:        'Cancelled',
};

/** Delivery fulfillment path (excludes cancelled) */
export const DELIVERY_STATUS_SEQUENCE = [
  'pending',
  'confirmed',
  'in_progress',
  'fulfilled',
  'out_for_delivery',
  'delivered',
];

/** Pickup fulfillment path (excludes cancelled) */
export const PICKUP_STATUS_SEQUENCE = [
  'pending',
  'confirmed',
  'in_progress',
  'ready_for_pickup',
  'picked_up',
];

/** Backward-compatible alias — defaults to delivery sequence */
export const STATUS_SEQUENCE = DELIVERY_STATUS_SEQUENCE;

export const FULFILLMENT_LABELS = {
  delivery: 'Delivery / Shipping',
  pickup: 'Pickup at Mill',
};

export const STATUS_TRACK_LABELS = {
  pending:          'Pending',
  confirmed:        'Confirmed',
  in_progress:      'Processing',
  fulfilled:        'Fulfilled',
  out_for_delivery: 'Delivering',
  delivered:        'Delivered',
  ready_for_pickup: 'Ready for Pickup',
  picked_up:        'Picked Up',
};
